import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import SessionPanel from './sessionPanel';
import BuyNowModal from './buyNowModal';
import promoCodeService from '../../services/promoCode';
import './sessionList.scss';

const buyNowDefault = () => ({
  showModal: false,
  programName: '',
  programId: '',
  sessionId: ''
});

export default class SessionList extends Component {

  static propTypes = {
    sessions: PropTypes.object.isRequired,
    programLookup: PropTypes.object.isRequired,
    resetAddEditClassForm: PropTypes.func.isRequired,
    updateSession: PropTypes.func.isRequired,
    buySession: PropTypes.func.isRequired
  };

  static contextTypes = {
    staff: PropTypes.bool,
    userId: PropTypes.string,
    archiveSession: PropTypes.func
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      buyNow: buyNowDefault(),
      activeSessionList: [],
      boughtBucket: [],
      trialBucket: [],
      expiredBucket: []
    };
    this.archiveLocks = {};
  }

  componentDidMount () {
    const buckets = this.calculateBuckets(this.props);
    this.setState(buckets);
    this.autoArchive(buckets.expiredBucket);
  }

  componentWillReceiveProps (nextProps/*, nextContext*/) {
    const buckets = this.calculateBuckets(nextProps);
    this.setState(buckets);
    this.autoArchive(buckets.expiredBucket);
  }

  autoArchive(list) {
    const { userId, archiveSession } = this.context;
    for (const session of list) {
      if (this.archiveLocks[session.id]) continue;
      this.archiveLocks[session.id] = true;
      archiveSession(session.id, session.programId, userId);
    }
  }

  calculateBuckets(props) {
    const { sessions } = props;
    const { sessionList: sessionIdList } = sessions;

    const activeSessionList = sessionIdList
      .map(id => ({ id, ...sessions.sessions[id] }))
      .filter(session => !session.archived);


    const sortBucket = (left, right) =>
      ((new Date(left.createdAt)) > (new Date(right.createdAt)))
        ? -1
        : 1;

    const boughtBucket = activeSessionList.filter(session =>
      (
        ((session.funding === "STRIPE") || (session.funding === "CONTRACT")) &&
        ((new Date(session.validUntil)) > (new Date()))
      ) || this.context.staff
    ).sort(sortBucket);

    const trialBucket = activeSessionList.filter(session =>
      (typeof(session.funding) === 'undefined') || (typeof(session.funding) === 'object') || session.funding === 'CANCELLED'
    ).sort(sortBucket);

    const expiredBucket = activeSessionList.filter(session =>
      ((session.funding === "STRIPE") || (session.funding === "CONTRACT")) && ((new Date(session.validUntil)) < (new Date()))
    ).sort(sortBucket);

    return {
      activeSessionList,
      boughtBucket,
      trialBucket,
      expiredBucket
    }
  }

  handleChargeProcessed (data) {
    const { buySession } = this.props;
    const { userId } = this.context;
    const { sessionId, programId, promoCode, charge } = data;
    const buyData = {
      stripeChargeId: charge.id,
      promoCode: promoCode ? promoCode.code : null,
      paidAmount: charge.amount / 100,
      paidCurrency: charge.currency
    };
    const promise = Promise.resolve();
    if (buyData.promoCode) {
      promise.then(() => promoCodeService.decreaseAvailable(buyData.promoCode));
    }
    promise.then(() => buySession(sessionId, programId, buyData, userId));
    return promise;
  }

  displayBuyNowModal(sessionId, programId, programName) {
    this.setState({
      buyNow: {
        sessionId,
        programId,
        programName,
        showModal: true
      }
    });
  }

  closeBuyNowModal() {
    this.setState({buyNow: buyNowDefault()});
  }

  render () {
    const { programLookup, resetAddEditClassForm, updateSession } = this.props;
    const { buyNow, activeSessionList, boughtBucket, trialBucket, expiredBucket } = this.state;

    const mapBucket = (bucket, expand, predicate) =>
      bucket.map(session =>
        <SessionPanel
          expanded={
            (expand === "all" || (predicate && session === bucket[0]))
              ? true
              : expand === "none"
              ? false
              : session === bucket[0]
          }
          key={session.id}
          id={session.id}
          program={programLookup[session.programId]}
          resetEditClassForm={resetAddEditClassForm}
          updateSession={updateSession}
          displayBuyNowModal={::this.displayBuyNowModal}
          highlightProgramOverview={false}
          {...session}
        />
      );

    return (
      <div className="panel-group session-panel-group">
        <BuyNowModal
            key={buyNow.sessionId}
            showModal={buyNow.showModal}
            onChargeProcessed={::this.handleChargeProcessed}
            closeModal={::this.closeBuyNowModal}
            programName={buyNow.programName}
            programId={buyNow.programId}
            sessionId={buyNow.sessionId} />
        <ReactCSSTransitionGroup
            transitionName="session-list"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={1000}>
          {
            ((activeSessionList.length === 1 && boughtBucket.length > 0) || boughtBucket.length > 0)
              && mapBucket(boughtBucket, "all", true)
          }
          {
            (activeSessionList.length === 1 && trialBucket.length > 0) && !this.context.staff
              ? mapBucket(trialBucket, "all", true)
              : (trialBucket.length > 0) && !this.context.staff
                ? mapBucket(trialBucket, "none", (boughtBucket.length === 0))
                : <div/>
          }
          {
            (activeSessionList.length === 1 && expiredBucket.length > 0) && !this.context.staff
              ? mapBucket(expiredBucket, "all", true)
              : (expiredBucket.length > 0) && !this.context.staff
                ? mapBucket(expiredBucket, "none", (boughtBucket.length === 0 && trialBucket.length === 0))
                : <div/>
          }
        </ReactCSSTransitionGroup>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/dashboard/sessionList.jsx